import { render } from "./Attractions.vue?vue&type=template&id=36c650b9&scoped=true"
import script from "./Attractions.vue?vue&type=script&lang=js"
export * from "./Attractions.vue?vue&type=script&lang=js"

import "./Attractions.css?vue&type=style&index=0&id=36c650b9&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Kwassim\\Documents\\Projects\\AcquaPalace\\vueapp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36c650b9"]])

export default __exports__